<template>
  <div>
    La feuille de présence fait désormais référence à
    {{ totalPresentMandates }} copropriétaires
    <span v-if="meeting.allowed_modalities.correspondence"
      >présents, représentés ou ayant vote par correspondance
    </span>
    <span v-else>présents ou représentés,</span>
    totalisant {{ totalPresentTantiemes }} tantièmes sur {{ totalMandatesTantiemes }}.
  </div>
</template>

<script>
import documentsMixin from "@/mixins/documents";

export default {
  mixins: [documentsMixin],
  inject: ["meeting"],
  props: ["event"],
  data() {
    return {
      totalPresentMandates: 0,
      totalPresentTantiemes: 0,
      totalMandatesTantiemes: 0,
    };
  },
  created() {
    const {
      totalPresentMandates,
      totalPresentTantiemes,
      totalMandatesTantiemes,
    } = this.getPresenceChangesInfo(this.meeting, this.event);

    this.totalPresentMandates = totalPresentMandates;
    this.totalPresentTantiemes = totalPresentTantiemes;
    this.totalMandatesTantiemes = totalMandatesTantiemes;
  },
};
</script>
